import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/sa/showcase`;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem("nex_token")}` });

export const showApi = {
  get: () => axios.get(BASE, { headers: headers() }).then((r) => r.data),
  prepare: () => axios.post(`${BASE}/prepare`, {}, { headers: headers() }).then((r) => r.data),
  setVoice: (v) => axios.put(`${BASE}/voice/${v}`, {}, { headers: headers() }).then((r) => r.data),
  sample: (v) => axios.get(`${BASE}/voice-sample/${v}`, { headers: headers(), responseType: "blob", timeout: 60000 }).then((r) => URL.createObjectURL(r.data)),
  audio: (seg, scene) => axios.get(`${BASE}/audio/${seg}/${scene}`, { headers: headers(), responseType: "blob", timeout: 120000 }).then((r) => URL.createObjectURL(r.data)),
};

export const publicShowApi = {
  get: () => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/showcase`).then((r) => r.data),
  audio: (seg, scene) => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/showcase/audio/${seg}/${scene}`, { responseType: "blob", timeout: 120000 }).then((r) => URL.createObjectURL(r.data)),
};

const MONEY = new Set(["savings_total", "avg_gross"]);
const fmtNum = (k, v) => (typeof v !== "number" ? v : MONEY.has(k) ? `$${v.toLocaleString()}` : v.toLocaleString());

/** '@served' → live number, '@m.loc' → Marcus series, trailing % or $ adds the unit. */
export function resolve(x, data) {
  if (typeof x !== "string" || !x.startsWith("@")) return x;
  let k = x.slice(1);
  let unit = "";
  if (/[%$]$/.test(k)) { unit = k.slice(-1); k = k.slice(0, -1); }
  const v = k.startsWith("m.") ? data?.marcus?.[k.slice(2)] : data?.[k];
  if (Array.isArray(v)) return v;
  if (unit === "$") return `$${Number(v || 0).toLocaleString()}`;
  return `${fmtNum(k, v)}${unit}`;
}

export const sentences = (t) => (t.match(/[^.!?]+[.!?]+["”’]?\s*|[^.!?]+$/g) || [t]).map((s) => s.trim()).filter(Boolean);

/** Index of the sentence being spoken now, by share of characters read (same clock the captions use). */
export function spokenIndex(parts, t, dur) {
  const total = parts.reduce((a, s) => a + s.length, 0) || 1;
  const k = dur ? t / dur : 0;
  let acc = 0;
  return Math.max(0, parts.findIndex((s) => { acc += s.length; return k <= acc / total; }));
}

const PHASE_RE = [/phase (one|i)\b/i, /phase (two|ii)\b/i, /phase (three|iii)\b/i];
/** Highest phase the narration has reached so far (never below the scene's own starting phase). */
export function phaseSpoken(spoken, base = 1) {
  let n = base;
  PHASE_RE.forEach((re, i) => { if (re.test(spoken)) n = Math.max(n, i + 1); });
  return n;
}

export const GOLD = "#d4a017";
export const ENGINES = [["Resident", "#f472b6"], ["Finance", "#34d399"], ["Pillar", "#a78bfa"], ["Document", "#38bdf8"], ["Partner", "#f59e0b"], ["Scheduler", "#22d3ee"], ["PACT Life Pass", "#fb7185"], ["Main Desk", "#d4a017"]];
